import React from 'react';
import SvgIcon from '@home/components/SvgIcon';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

export interface IFullScreenHeaderProps extends IBaseProps {
  title?: string | React.ReactElement | null;
  exitFullScreen?: () => void;
}

const FullScreenHeader: React.FC<IFullScreenHeaderProps> = (props) => {
  const { title, exitFullScreen } = props;

  const handleExitFullScreen = (e?: React.SyntheticEvent<HTMLDivElement>) => {
    e?.stopPropagation();
    exitFullScreen?.();
  };

  return (
    <div className="dbs-fullscreen-header">
      <div className="dbs-fullscreen-header-inner">
        <div className="dbs-fullscreen-header-title">{title}</div>
        <div className="dbs-fullscreen-header-operate" onClick={handleExitFullScreen}>
          <SvgIcon className="dbs-fullscreen-close" type="clonse"></SvgIcon>
        </div>
      </div>
    </div>
  );
};

export default FullScreenHeader;
